module.exports = __webpack_public_path__ + "img/modelo-eg1.04f973f7.png";